import React from 'react'
import { OverflowMenu, OverflowMenuItem } from '../../../../../OverflowMenu'
import '../../../TableActions/index.scss'
const ActionDropdown = (props) => {
  const { text: primaryLabel, componentProps } = props

  const menu = componentProps?.menu ?? []

  return (
    <>
      <OverflowMenu
        className='overflowFilter bx--btn bx--btn--primary'
        renderIcon={() => <div>{primaryLabel}</div>}
      >
        {menu.map(({ label, action }, idx) => (
          <OverflowMenuItem
            key={`${label}-${idx}`}
            onClick={action}
            itemText={label}
          />
        ))}
      </OverflowMenu>
    </>
  )
}

export default ActionDropdown
